// TrueNPS — Light Mode Design System (Refined SaaS)
export const T = {
  // ─── Backgrounds ─────────────────────────────────────────────────────────────
  bg:            "#F8F9FB",
  bgBase:        "#F0F2F5",
  bgCard:        "#FFFFFF",
  bgCardHover:   "#F5F7FA",
  bgSidebar:     "#FFFFFF",
  bgInput:       "#F3F4F6",
  bgModal:       "#FFFFFF",

  // ─── Borders ─────────────────────────────────────────────────────────────────
  border:        "#E5E7EB",
  borderActive:  "#6366F1",
  borderFocus:   "#6366F1",

  // ─── Brand / Accent ───────────────────────────────────────────────────────────
  accent:        "#6366F1",          // indigo-500 — cor principal
  accentDim:     "rgba(99,102,241,0.10)",
  accentHover:   "#4F46E5",
  primary:       "#6366F1",
  primaryGlow:   "rgba(99,102,241,0.15)",

  // ─── Semantic Colors ──────────────────────────────────────────────────────────
  green:         "#10B981",          // emerald-500
  greenGlow:     "rgba(16,185,129,0.12)",
  amber:         "#F59E0B",          // amber-500
  red:           "#EF4444",          // red-500
  redGlow:       "rgba(239,68,68,0.12)",
  purple:        "#8B5CF6",          // violet-500
  teal:          "#14B8A6",          // teal-500
  blue:          "#3B82F6",          // blue-500
  pink:          "#EC4899",

  // ─── Text ─────────────────────────────────────────────────────────────────────
  textHi:        "#111827",          // gray-900
  textMid:       "#374151",          // gray-700
  textLow:       "#9CA3AF",          // gray-400

  // ─── Typography ───────────────────────────────────────────────────────────────
  fontTitle:     "'Plus Jakarta Sans', system-ui, sans-serif",
  fontBody:      "'IBM Plex Sans', system-ui, sans-serif",
  fontMono:      "'JetBrains Mono', 'Fira Code', monospace",
  font:          "'IBM Plex Sans', system-ui, sans-serif",

  // ─── Radius ───────────────────────────────────────────────────────────────────
  radius:        16,          // cards
  radiusSm:      10,          // botoes, inputs, icon boxes
  radiusXs:      6,           // chips pequenos
  radiusFull:    9999,        // pills, badges

  // ─── Shadows ──────────────────────────────────────────────────────────────────
  shadow:        "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.03)",
  shadowCard:    "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.03)",
  shadowMd:      "0 4px 12px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)",
  shadowLg:      "0 8px 24px rgba(0,0,0,0.10)",

  // ─── Gradients ────────────────────────────────────────────────────────────────
  gradientHero:   "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
  gradientAccent: "linear-gradient(135deg, #6366F1, #8B5CF6)",
  gradientGreen:  "linear-gradient(135deg, #059669, #10B981)",
  gradientRed:    "linear-gradient(135deg, #DC2626, #EF4444)",
  gradientAmber:  "linear-gradient(135deg, #D97706, #F59E0B)",
  gradientBlue:   "linear-gradient(135deg, #2563EB, #3B82F6)",

  // ─── Page Layout (padronizado para TODAS as paginas) ──────────────────────────
  pagePadding:   "32px 40px",
  pageMaxWidth:  1400,

  // ─── Titulos padronizados ─────────────────────────────────────────────────────
  titleSize:     26,
  titleWeight:   800,
  subtitleSize:  14,

  // ─── Icon Boxes padronizados ──────────────────────────────────────────────────
  iconBoxSize:     40,
  iconBoxRadius:   12,
  iconBoxSizeSm:   32,
  iconBoxRadiusSm: 10,

  // ─── Card padronizado ─────────────────────────────────────────────────────────
  cardPadding:      "24px 28px",
  cardShadowHover:  "0 8px 24px rgba(0,0,0,0.06)",

  // ─── Input padronizado ────────────────────────────────────────────────────────
  inputPadding:         "12px 16px",
  inputPaddingWithIcon: "12px 16px 12px 44px",
  inputRadius:          12,

  // ─── Table padronizado ────────────────────────────────────────────────────────
  tableHeaderPadding:  "14px 20px",
  tableCellPadding:    "14px 20px",
  tableHeaderFontSize: 11,
  tableHeaderWeight:   700,

  // ─── Animations ───────────────────────────────────────────────────────────────
  transition:       "all 0.15s ease",
  transitionFast:   "all 0.15s cubic-bezier(0.16, 1, 0.3, 1)",
  transitionNormal: "all 0.25s cubic-bezier(0.16, 1, 0.3, 1)",
  transitionSlow:   "all 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
  transitionSpring: "all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)",

  // ─── Misc ─────────────────────────────────────────────────────────────────────
  blur:          "none",
};
